import React from 'react'
import axios from 'axios'

class Quiz extends React.Component{
	constructor(props){
		super(props)
		this.state = {
			questions: [], //list of questions
			questionMax: 10, //max number of question
			questionN: 0, //id of the current question
			answerShowed: false, //Determine if the answer is showed
			answers: [0,0,0], //actual answers
			mistakes: [], // array of all the mistakes
			miskakesN: 0
		}
	}

	componentDidMount(){

	}

	getQuestions(){
		var self = this
		axios.get('http://api.permis.qwertz.me/questions/random').then(function (response) {
			if(response.data.data.length === 50){
				self.setState({
					questions: response.data.data
				})
			}
		})
	}

	correctF(correct, user){
		var wrong = 0
		if(correct[0] != user[0]){
			wrong++
		}
		if(correct[1] != user[1]){
			wrong++		
		}
		if(correct[2] != user[2]){
			wrong++		
		}
		return wrong
	}
	
	correct(){
		const {questions, questionN, answers, mistakes, miskakesN } = this.state
		var result = this.correctF(questions[questionN].Correction.split(''), answers)
		var pushed = questions[questionN]
		pushed['answer'] = questions[questionN].Correction.split('')
		mistakes.push(pushed)

		if(result >= 1){
			this.setState({miskakesN: miskakesN+result, mistakes: mistakes})
		}
		this.setState({answerShowed: true})
	}

	next(){
		const { questionN, questionMax, miskakesN, mistakes } = this.state
		if(questionN+1 == questionMax){
			this.props.infos({mN: miskakesN, m: mistakes, n: questionMax})
			this.props.setStatus("end")
		}else{
			this.setState({questionN: questionN+1, answers: [0,0,0], answerShowed: false})
		}
	}

	prev(){
		const { questionN } = this.state
		this.setState({
			questionN: questionN-1
		})
	}


	answerHandle(e){
		const { answers } = this.state
		answers[e.target.id] = e.target.checked ? 1 : 0
		this.setState({answers: answers})
	}

	render(){
		const { questions, questionN, questionMax, miskakesN, answers, answerShowed } = this.state
		//var qPopulated = false
		if(questions.length <= 0){
			this.getQuestions()
		}
		var test = ["","",""]

		if(answerShowed){
			test[0] = 1 == questions[questionN].Correction[0] ? 'true' : 'false'
			test[1] = 1 == questions[questionN].Correction[1] ? 'true' : 'false'
			test[2] = 1 == questions[questionN].Correction[2] ? 'true' : 'false'
		}

		if(questions.length === 50){
			return (
			<div className="container">
				<h3 className="askTitle">Question {questionN+1}/{questionMax} - <b>{miskakesN}</b> faute{ (miskakesN>1) ? 's' : '' }</h3>
				<p className="Align"> </p>
				<div className="row">
					<div className="col-md-6">
						<img src={"http://api.permis.qwertz.me/imagesGET/"+questions[questionN].Image} className="img-fluid askImg" alt="" />
					</div>
					<div className="col-md-6 ask">
						<b>{questions[questionN].Question}</b>
						<div className="control-group">
							<label className="control control-checkbox noselect">
								<div className="spaceText">a) {questions[questionN].Answer1}</div>
								<input id="0" onChange={this.answerHandle.bind(this)} disabled={answerShowed} checked={answers[0]} type="checkbox"/>
								<div className={"control_indicator " + test[0]}></div>
							</label>
							<label className="control control-checkbox noselect">
								<div className="spaceText">b) {questions[questionN].Answer2}</div>
								<input id="1" onChange={this.answerHandle.bind(this)} disabled={answerShowed} checked={answers[1]} type="checkbox"/>
								<div className={"control_indicator " + test[1]}></div>
							</label>
							<label className="control control-checkbox noselect">
								<div className="spaceText">c) {questions[questionN].Answer3}</div>
								<input id="2" onChange={this.answerHandle.bind(this)} disabled={answerShowed} checked={answers[2]} type="checkbox"/>
								<div className={"control_indicator " + test[2]}></div>
							</label>
						</div>
						<div className="btnValider">
							<button type="button" onClick={() => this.correct()} className="btn btn-success" style={{visibility: this.state.answerShowed ? 'hidden': 'visible'}}>Vérifier la réponse</button>
							<button type="button" onClick={() => this.next()} style={{visibility: this.state.answerShowed ? 'visible': 'hidden', display:'block'}} className="btn btn-success">Suivant</button>
						</div>
					</div>
				</div>
			</div>
			)
		}else{
			return (
				<div className="container loading">
					<img src="./assets/loading.gif" alt=""/>
					<span>Chargement des questions ...</span>
				</div>
			)
		}
		

		
	}
}
export default Quiz


// WEBPACK FOOTER //
// ./src/components/quiz.js